import CommonsService from '@/services/commons.service'
import { LoadingSpinner } from '../LoadingSpinner'
import './loading-screen.sass'

function LoadingScreen () {
  return (
    <div className="loading-screen-container">
      <div className="loading-screen-main-content">
        <div className="loading-spinner-container">
          <LoadingSpinner/>
        </div>
        {!CommonsService.urlIncludesString('auth') &&
          <div className="loading-text">
            Welcome to Boxes. Enjoy.
          </div>
        }
      </div>
    </div>
  )
}

export default LoadingScreen
